import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function About() {
  const [typedText, setTypedText] = useState('');
  const [roleIndex, setRoleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const roles = ['Data Analyst', 'Software Engineer', 'Frontend Developer', 'Graphic Designer'];
  const photos = ['/ajang3.jpeg', '/ajang4.jpeg', '/ajang2.jpeg', '/ajang.jpeg', '/IMG_2769.jpg'];

  useEffect(() => {
    const interval = setInterval(() => {
      setPhotoIndex(prev => (prev + 1) % photos.length);
    }, 3500);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const currentRole = roles[roleIndex];
    const speed = isDeleting ? 30 : 80;
    const timer = setTimeout(() => {
      if (!isDeleting) {
        if (typedText.length < currentRole.length) {
          setTypedText(currentRole.slice(0, typedText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        if (typedText.length > 0) {
          setTypedText(currentRole.slice(0, typedText.length - 1));
        } else {
          setIsDeleting(false);
          setRoleIndex((roleIndex + 1) % roles.length);
        }
      }
    }, speed);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typedText, isDeleting, roleIndex]);

  const whoCards = [
    { title: 'Who I Am', text: 'Ajang Akoi Arok is a South Sudanese Software Engineer, creative thinker, and emerging leader passionate about technology, design, and social impact. With a strong foundation in frontend development, graphic design, and data analysis, he blends logic with creativity to build solutions that are both functional and visually compelling.' },
    { title: 'Current Focus', text: "Currently pursuing a Bachelor's degree at African Leadership University, sharpening technical and leadership abilities to build scalable digital solutions. Focused on developing user-centered web applications, improving digital experiences, and leveraging data to drive informed decision-making." },
    { title: 'Track Record', text: 'Built and contributed to multiple digital projects, developed responsive web applications, designed impactful visual identities, and analyzed datasets to uncover meaningful insights. Successfully led collaborative projects and consistently delivered high-quality results under pressure.' },
    { title: 'Global Perspective', text: 'Through cross-cultural collaboration, academic experiences, and leadership exposure, developed a mindset that values diversity, innovation, and adaptability. Carries himself as a representative of South Sudanese excellence on the global stage.' },
    { title: 'Leadership Philosophy', text: 'Leadership is about service, growth, and responsibility, not just achieving results but uplifting others along the way. Values integrity, continuous improvement, and bold action. Mission is to use technology as a tool for empowerment.' },
  ];

  const storyCards = [
    { icon: 'fa-solid fa-route',         title: 'My Journey',     text: 'As a student at African Leadership University, my journey has been defined by growth, resilience, and purpose. I am building a strong foundation in software engineering while developing the leadership skills necessary to create meaningful change. Through roles in communication, social media strategy, and technical development, I have learned how to bridge ideas with action.' },
    { icon: 'fa-solid fa-bolt',          title: 'What Drives Me', text: 'I am driven by a deep commitment to using technology as a tool for transformation. I believe innovation should address real-world challenges and create opportunities where they are most needed. For me, technology is not just code, it is a pathway to empowerment.' },
    { icon: 'fa-solid fa-people-group',  title: 'My Approach',    text: 'I believe growth happens at the intersection of continuous learning and collaboration. Serving as Communication Lead at Nile Orphan Care and COO at Youth Growth Portal strengthened my understanding of teamwork, strategy, and the power of clear communication.' },
    { icon: 'fa-solid fa-earth-africa',  title: 'Beyond Code',    text: 'Beyond academics, I actively explore emerging technologies, contribute to community-driven initiatives, and mentor aspiring developers. My long-term vision is to leverage technology to create sustainable opportunities for youth empowerment.' },
  ];

  const services = [
    {
      icon: 'fa-solid fa-code',
      title: 'Web Development',
      desc: 'Building responsive and modern web applications with the latest technologies.',
      techs: ['React', 'JavaScript', 'HTML', 'CSS'],
    },
    {
      icon: 'fa-solid fa-pen-ruler',
      title: 'Graphic Design',
      desc: 'Creating stunning visual designs and brand identities that leave lasting impressions.',
      techs: ['Adobe Illustrator', 'Canva', 'Figma'],
    },
    {
      icon: 'fa-solid fa-bullhorn',
      title: 'Social Media Marketing',
      desc: 'Building brand presence and engaging audiences across platforms with strategic content.',
      techs: ['Content Strategy', 'Analytics', 'Branding'],
    },
    {
      icon: 'fa-solid fa-chart-line',
      title: 'Data Analysis',
      desc: 'Transforming raw data into actionable insights and clear visualizations.',
      techs: ['Python', 'Excel', 'Data Visualization'],
    },
    {
      icon: 'fa-solid fa-diagram-project',
      title: 'Project Management',
      desc: 'Leading teams and managing projects from concept to successful delivery.',
      techs: ['Agile', 'Planning', 'Leadership'],
    },
    {
      icon: 'fa-solid fa-comments',
      title: 'Communication',
      desc: 'Effective communication strategies and stakeholder engagement for impactful outcomes.',
      techs: ['Public Speaking', 'Writing', 'Strategy'],
    },
  ];

  return (
    <div className="page-wrapper">

      {/* ── HERO ── */}
      <section className="ab-hero">
        <div className="ab-hero-photo-bg">
          {photos.map((src, i) => (
            <img
              key={i}
              src={src}
              alt="Ajang Akoi Arok"
              className={`ab-hero-photo ${i === photoIndex ? 'ab-hero-photo-active' : ''}`}
            />
          ))}
        </div>
        <div className="ab-hero-box">
          <div className="ab-hero-box-accent"></div>
          <span className="ab-hero-welcome">WELCOME</span>
          <h1 className="ab-hero-name">Who is Ajang Akoi Arok?</h1>
          <p className="ab-hero-bio">A South Sudanese Software Engineer, creative thinker, and emerging leader passionate about technology, design, and social impact. Currently pursuing a Bachelor of Science in Software Engineering at African Leadership University in Kigali, Rwanda. Driven by a mission to use technology as a tool for empowerment and youth development.</p>
          <p className="ab-hero-role">
            <span style={{color:'#29abe2',fontWeight:600}}>{typedText}</span>
            <span className="typed-cursor">|</span>
          </p>
          <Link to="/about#ab-who" className="ab-hero-cta">Learn More About Me →</Link>
        </div>
        <div className="ab-hero-stripe"></div>
      </section>

      {/* ── WHO I AM ── */}
      <section id="ab-who" className="ab-section ab-section-white">
        <div className="ab-container">
          <div className="ab-profile-pro-card">
            <div className="ab-profile-pro-top">
              <div className="ab-profile-pro-photo-wrap">
                <img src="/ajang3.jpeg" alt="Ajang Akoi Arok" className="ab-profile-pro-photo" />
              </div>
              <div className="ab-profile-pro-intro">
                <span className="insights-label">Get To Know Me</span>
                <h2 className="ab-section-heading">Who I Am</h2>
                <p className="ab-profile-pro-lead">{whoCards[0].text}</p>
              </div>
            </div>

            <div className="ab-profile-pro-sections">
              {whoCards.slice(1).map((c, i) => (
                <div key={i} className="ab-profile-pro-block">
                  <h4 className="ab-profile-pro-title">{c.title}</h4>
                  <p className="ab-profile-pro-text">{c.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── MY STORY ── */}
      <section className="ab-section ab-section-gray">
        <div className="ab-container">
          <div className="ab-section-header">
            <span className="insights-label">My Journey</span>
            <h2 className="ab-section-heading">My Story</h2>
          </div>
          <div className="ab-story-grid">
            {storyCards.map((c, i) => (
              <div key={i} className="ab-story-card">
                <i className={`${c.icon} ab-story-icon`}></i>
                <h3 className="ab-story-title">{c.title}</h3>
                <p className="ab-story-text">{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICES (COMBINED INTO ABOUT) ── */}
      <section className="ab-section ab-section-white">
        <div className="page-container">
          <div className="ab-section-header">
            <span className="insights-label">What I Offer</span>
            <h2 className="ab-section-heading">My Services</h2>
          </div>

          <div className="services-pro-grid">
            {services.map((s, i) => (
              <div key={i} className="service-pro-card">
                <div className="service-pro-icon-wrap">
                  <i className={s.icon} style={{ fontSize: '2rem', color: '#29abe2' }}></i>
                </div>
                <div className="service-pro-body">
                  <h3 className="service-pro-title">{s.title}</h3>
                  <p className="service-pro-desc">{s.desc}</p>
                  <div className="service-pro-techs">
                    {s.techs.map((t, j) => (
                      <span key={j} className="tech-chip">{t}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default About;
